if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const variantInput = this.form && this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;
        if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        var idInput = this.form && this.form.querySelector('input[name="id"]');
        var formId = this.form && this.form.id;
        var sectionId = this.dataset.sectionId || (formId && formId.replace('product-form-', ''));
        var variantPicker = null;
        if (sectionId) {
          variantPicker = document.querySelector('variant-radios[data-section="' + sectionId + '"]') || document.querySelector('variant-selects[data-section="' + sectionId + '"]');
        }
        if (!variantPicker && formId) {
          var allPickers = document.querySelectorAll('variant-radios, variant-selects');
          for (var i = 0; i < allPickers.length; i++) {
            var inp = allPickers[i].querySelector('input[form="' + formId + '"], select[form="' + formId + '"]');
            if (inp) { variantPicker = allPickers[i]; break; }
          }
        }
        if (!variantPicker && this.closest) {
          var sectionEl = this.closest('[id^="shopify-section-"]');
          if (sectionEl) {
            var sid = sectionEl.id.replace('shopify-section-', '');
            variantPicker = document.querySelector('variant-radios[data-section="' + sid + '"]') || document.querySelector('variant-selects[data-section="' + sid + '"]');
          }
        }
        if (idInput && variantPicker) {
          var resolvedVariantId = null;
          var script = variantPicker.querySelector('script[type="application/json"]');
          if (script && script.textContent) {
            try {
              var variants = JSON.parse(script.textContent);
              var selectedValues = [];
              var fieldsets = variantPicker.querySelectorAll('fieldset');
              if (fieldsets.length) {
                fieldsets.forEach(function(fs) {
                  var checked = fs.querySelector('input[type="radio"]:checked') || fs.querySelector('input[type="radio"]');
                  if (checked) selectedValues.push(String(checked.value).trim());
                });
              }
              if (selectedValues.length === 0) {
                var checkedRadios = variantPicker.querySelectorAll('input[type="radio"]:checked');
                for (var r = 0; r < checkedRadios.length; r++) selectedValues.push(String(checkedRadios[r].value).trim());
              }
              if (selectedValues.length === 0) {
                var sels = variantPicker.querySelectorAll('select');
                sels.forEach(function(s) { selectedValues.push(String(s.value).trim()); });
              }
              var found = variants.find(function(v) {
                var opts = Array.isArray(v.options) && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(Boolean);
                if (opts.length !== selectedValues.length) return false;
                return opts.every(function(o, i) { return String(o).trim() === selectedValues[i]; });
              });
              if (!found && selectedValues.length === 1) {
                var val = selectedValues[0];
                found = variants.find(function(v) {
                  return (v.option1 != null && String(v.option1).trim() === val) ||
                    (v.option2 != null && String(v.option2).trim() === val) ||
                    (v.option3 != null && String(v.option3).trim() === val);
                });
              }
              if (found) resolvedVariantId = found.id;
            } catch (e) {}
          }
          if (!resolvedVariantId && typeof variantPicker.updateOptions === 'function') {
            variantPicker.updateOptions();
            variantPicker.updateMasterId();
            if (variantPicker.currentVariant) resolvedVariantId = variantPicker.currentVariant.id;
          }
          if (resolvedVariantId) {
            idInput.disabled = false;
            idInput.value = resolvedVariantId;
          }
        }

        if (idInput && (!idInput.value || idInput.value === '0')) {
          this.handleErrorMessage(typeof window.variantStrings !== 'undefined' && window.variantStrings.unavailable_with_option ? window.variantStrings.unavailable_with_option.replace('[value]', '') : 'Selecciona una opci\u00f3n');
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        config.credentials = 'include';

        this.skipCart = false;
        if (idInput && idInput.dataset.skipCart === 'true') this.skipCart = true;
        
                fetch(`${routes.cart_url}.js`, { credentials: 'include' })
          .then((response) => {
            if (!response.ok) return {};
            return response.json().catch(function() { return {}; });
          })
          .then((cartState) => {
            if (cartState && cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => {
            if (response.status === 401) {
              this.handleErrorMessage('La tienda está protegida con contraseña. Introduce la contraseña de nuevo o desactívala en Configuración para probar el carrito.');
              this.showAddToStoreFallback();
              this.error = true;
              return { _skip: true };
            }
            return response.json()
              .then((data) => ({ ok: response.ok, status: response.status, data }))
              .catch(function() {
                return { _parseError: true, status: response.status };
              });
          })
          .then((result) => {
            if (result && result._parseError) {
              if (result.status === 401) {
                this.handleErrorMessage('La tienda está protegida con contraseña. Introduce la contraseña de nuevo o desactívala en Configuración para probar el carrito.');
                this.showAddToStoreFallback();
              } else {
                this.handleErrorMessage('No se pudo conectar. Comprueba la conexión o la contraseña de la tienda.');
              }
              this.error = true;
              return { _skip: true };
            }
            return result;
          })
          .then((result) => {
            if (result && result._skip) return;
            var response = result && result.data;
            if (!response) return;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || (response.message || 'Error al añadir al carrito'));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('No se pudo conectar. Comprueba la conexión o la contraseña de la tienda.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;
        config.credentials = 'include';

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        var oldLink = this.errorMessageWrapper.querySelector('.product-form__add-to-store-fallback');
        if (oldLink) oldLink.remove();
      }

      showAddToStoreFallback() {
        if (!this.form || !this.errorMessageWrapper) return;
        var origin = typeof window.shopifyStoreOrigin !== 'undefined' ? window.shopifyStoreOrigin : (window.shopUrl || '');
        var path = (typeof window.routes !== 'undefined' && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        if (path.indexOf('http') === 0) path = path.replace(/^https?:\/\/[^/]+/, '');
        var action = origin ? (origin.replace(/\/$/, '') + path) : '';
        if (!action) return;
        var link = document.createElement('a');
        link.href = '#';
        link.className = 'product-form__add-to-store-fallback';
        link.style.display = 'block';
        link.style.marginTop = '0.5em';
        link.style.fontSize = '0.9em';
        link.textContent = 'Añadir en la tienda (abre en la tienda real)';
        link.addEventListener('click', function(e) {
          e.preventDefault();
          this.form.action = action;
          this.form.method = 'post';
          this.form.submit();
        }.bind(this));
        this.errorMessageWrapper.appendChild(link);
      }
    }
  );
}
